export default __webpack_public_path__ + "static/media/migrating.c069e4ae.png";